import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { thunkGoToGameGuidePage } from '../redux/actions/gameGuideActions';
import { useAppDispatch } from '../redux/store';
import { LIGHT_YELLOW_COLOR, YELLOW_COLOR } from '../styles/colors';
import { ALL_GAME_GUIDE_PAGES } from './gameGuidePages';
import { isGameGuidePath } from './gameGuideUtils';
export const GAME_GUIDE_LINK_CSS = css `
  color: ${YELLOW_COLOR};
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: ${LIGHT_YELLOW_COLOR};
  }
`;
function getLabel(page, label) {
    return label || ALL_GAME_GUIDE_PAGES[page].title;
}
const GameGuideDispatchLink = ({ page, label }) => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        dispatch(thunkGoToGameGuidePage(page));
    }, [dispatch, page]);
    return (_jsx("a", { css: GAME_GUIDE_LINK_CSS, onClick: onClick, role: 'button', children: getLabel(page, label) }));
};
const GameGuideAnchorLink = ({ page, label }) => {
    return (_jsx(Link, { css: GAME_GUIDE_LINK_CSS, to: `/guide/${page}`, children: getLabel(page, label) }));
};
export const GameGuideLink = ({ page, label }) => {
    return isGameGuidePath() ? (_jsx(GameGuideAnchorLink, { page: page, label: label })) : (_jsx(GameGuideDispatchLink, { page: page, label: label }));
};
